import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { ImageLightBoxHeader } from './image_light_box_header';
import { ImageLightBoxContent } from './image_light_box_content';

function ImageLightBox(props) {
    const title = props.data ? props.data.title : '';

    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['image-light-box__lightbox']}
        >
            <div className="image-light-box">
                <ImageLightBoxHeader title={title} />
                <ImageLightBoxContent
                    data={props.data}
                    expanded={props.expanded}
                    LightBoxVisible={props.LightBoxVisible}
                    error={props.error}
                    onExpand={props.onExpand}
                    onClose={props.onClose}
                />
            </div>
        </Lightbox>
    );
}

ImageLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    LightBoxVisible: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { ImageLightBox };
